import { put, call, select } from 'redux-saga/effects';
import { getIsAuthenticated } from '../selectors/login';
import { ApiConstants } from '../constants/actions';
import Moment from './MomentExtensions';
import { Notify } from './NotificationHelper';

interface LoginResponse {
  expiresIn: number;
  [key: string]: any;
}

export interface LoginState {
  validTo: number;
  isAuthenticated: boolean;
  [key: string]: any;
}

export function* SetAuthorizationData(loginResponse: LoginResponse) {
  const validTo = Moment().unix() + loginResponse.expiresIn;

  yield put({
    type: `${ApiConstants.LOGIN_ACTION}_SUCCESS`,
    payload: {
      ...loginResponse,
      validTo
    }
  });
}

export const checkIfTokenExpires = (validTo: number | null): boolean =>
  validTo !== null &&
  validTo !== undefined &&
  Moment().isAfter(Moment.unix(validTo));

export const shouldRefreshToken = (
  validTo: number | null,
  expiresIn: number
): boolean => {
  if (validTo === null || validTo === undefined) return false;
  const refreshTokenDate = Moment.unix(validTo - expiresIn / 2);
  return Moment().isAfter(refreshTokenDate);
};

export const userIsAuthorizedAndTokenIsValid = (
  loginState: LoginState
): boolean =>
  loginState.validTo !== undefined &&
  loginState.isAuthenticated &&
  Moment().isBefore(Moment.unix(loginState.validTo));

export default {
  checkIfTokenExpires,
  shouldRefreshToken,
  userIsAuthorizedAndTokenIsValid
};

export function* HandleUnauthorizedError(login: LoginState) {
  if (login.isAuthenticated && checkIfTokenExpires(login.validTo)) {
    yield put({
      type: `${ApiConstants.LOGOUT_ACTION}_REQUEST`,
      sessionExpired: true
    });
  } else {
    yield call(Notify, 'forms.user_information.incorrect_password', 'error');
  }
}

export function* HandleUnauthorizedErrorAndLogout() {
  const isAuthenticated = yield select(getIsAuthenticated);
  if (isAuthenticated) {
    yield put({
      type: `${ApiConstants.LOGOUT_ACTION}_REQUEST`,
      sessionExpired: true
    });
  }
}
